import * as React from "react";

const ChatIcon = ({ color = "#007AFF", fillcolor,height,width }) => ( // Default color if none is provided
  <svg
    width={width || 64}
    height={ height || 64}
    viewBox="0 0 64 64"
    fill="none"  // Prevents default fill color
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C8 6.686 10.686 4 14 4H50C53.314 4 56 6.686 56 10V38C56 41.314 53.314 44 50 44H19.172L8 55.172V10Z"
      fill={color}  // ✅ Uses the color prop dynamically
    />
    <circle cx={22} cy={24} r={2.5} fill={fillcolor} />
    <circle cx={32} cy={24} r={2.5} fill={fillcolor}/>
    <circle cx={42} cy={24} r={2.5} fill={fillcolor} />
  </svg>
);

export default ChatIcon;
